// import { Col, message } from "antd";
// import { useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import Table from "@components/Table";
// import { getColumns } from "./config";
// import {
//   ErrorServices,
//   salaryRangeApi,
//   useDeleteSalaryRangeMutation,
//   useFetchCompanySalaryRangesQuery,
//   useUploadSalaryRangesMutation,
// } from "@services";
// import AddSalaryRange from "./AddSalaryRange";
// import { ISalaryRange } from "@types";
// import SalaryRangeVersions from "./Versions";
// import Upload from "@components/Upload";
// import { useTypedSelector } from "@hooks";
// import { checkPermission } from "@/utils";
// import { permissions } from "@/router";
// import CustomButton from "@/components/customButton";
// import { MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
// import SearchBox from "@/components/searchInput";
// import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
// import customErrorMessage from "@/components/CustomErrorMessage";

// const SalaryRange = () => {
//   const { company } = useTypedSelector(state => state.auth?.user!);
//   const { id: company_id } = company!;
//   const dispatch = useDispatch();
//   const salary_range_id = useRef<any>(null);

//   const [page, setPage] = useState(1);
//   const [searchInput, setSearchInput] = useState("");
//   const [pageSize, setPageSize] = useState(10);
//   const [isVisible, setIsVisible] = useState(false);
//   const [isUploadModal, setIsUploadModal] = useState(false);
//   const [selectedSalaryRange, setSelectedSalaryRange] =
//     useState<ISalaryRange | null>(null);
//   const [isVersionsModal, setIsVersionsModal] = useState(false);
//   const [sortBy, setSortBy] = useState<string | null>(null);

//   const { data: salaryRanges, isLoading } = useFetchCompanySalaryRangesQuery({
//     company_id,
//     page,
//     page_size: pageSize,
//     sort_by: sortBy,
//   });

//   const { data, pagination } = salaryRanges || {};

//   const [deleteSalaryRange, { isLoading: isDeleting }] =
//     useDeleteSalaryRangeMutation();

//   const [uploadFile, setUploadFile] = useState({
//     file: null,
//     active: false,
//   });

//   const [uploadJobGrades, { isLoading: isUploading }] =
//     useUploadSalaryRangesMutation();

//   const editSalaryRange = (salaryRange: ISalaryRange) => {
//     setSelectedSalaryRange(salaryRange);
//     setIsVisible(true);
//   };

//   const updatedData =
//     data &&
//     data.map((item: any) => ({
//       ...item,
//       salary_mid: formatNumberWithCommas(item.salary_mid) || item.salary_mid,
//       salary_min: formatNumberWithCommas(item.salary_min) || item.salary_min,
//       salary_max: formatNumberWithCommas(item.salary_max) || item.salary_max,
//     }));

//   const removeSalaryRange = async (id: number) => {
//     try {
//       salary_range_id.current = id;
//       await deleteSalaryRange({ company_id, id }).unwrap();
//       message.success("Salary range deleted successfully!");
//     } catch (error) {
//       ErrorServices(error);
//     }
//   };

//   const handleUpload = async () => {
//     const { file, active }: { file: any; active: boolean } = uploadFile;
//     setIsUploadModal(false);
//     try {
//       const formData = new FormData();
//       formData.append("attachment", file!, file?.name!);
//       const res = await uploadJobGrades({
//         company_id,
//         active,
//         body: formData,
//       }).unwrap();
//       message.success(res?.message);
//     } catch (error: any) {
//       customErrorMessage(error?.message);
//     }
//   };

//   const download = (id?: number) => {
//     dispatch(
//       salaryRangeApi.endpoints.downloadSalaryRanges.initiate(
//         {
//           company_id,
//           version_id: id || null,
//         },
//         {
//           subscribe: false,
//           forceRefetch: true,
//         }
//       )
//     );
//   };

//   // ✅ ALL COLUMNS
//   const allColumns = getColumns({
//     editSalaryRange,
//     isDeleting,
//     salary_range_id,
//     removeSalaryRange,
//   });

//   // ✅ COLUMN VISIBILITY STATE
//   const [visibleColumnKeys, setVisibleColumnKeys] = useState(
//     allColumns.map(col => col.key)
//   );

//   // ✅ FILTERED COLUMNS
//   const filteredColumns = allColumns.filter(col =>
//     visibleColumnKeys.includes(col.key)
//   );

//   return (
//     <>
//       {isUploadModal && (
//         <Upload
//           title="Upload Salary Ranges"
//           onSubmit={handleUpload}
//           isVisible={isUploadModal}
//           setIsVisible={setIsUploadModal}
//           file={uploadFile}
//           setFile={setUploadFile}
//         />
//       )}

//       {isVisible && (
//         <AddSalaryRange
//           selectedSalaryRange={selectedSalaryRange}
//           setSelectedSalaryRange={setSelectedSalaryRange}
//           isVisible={isVisible}
//           setIsVisible={setIsVisible}
//         />
//       )}

//       {isVersionsModal && (
//         <SalaryRangeVersions
//           isVisible={isVersionsModal}
//           setIsVisible={setIsVersionsModal}
//           download={download}
//         />
//       )}

//       {/* HEADER */}
//       <div className="bg-themeCore ">
//         <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center ">
//           <div className="title text-themeBlue font-medium text-3xl">
//             Salary Range
//           </div>

//           <div className="flex flex-row justify-between">
//             {(checkPermission(permissions.UPDATE_SALARY_RANGE) ||
//               checkPermission(permissions.CREATE_SALARY_RANGE)) && (
//                 <CustomButton
//                   isLoading={isUploading}
//                   onClick={() => setIsUploadModal(true)}
//                   btnName="Upload"
//                   customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder"
//                   iconPosition="left"
//                 >
//                   <MdOutlineFileUpload size={20} />
//                 </CustomButton>
//               )}

//             <CustomButton
//               onClick={() => download()}
//               btnName="Download"
//               customClasses="shadow-md font-medium border py-1 px-6 ml-4"
//             >
//               <MdOutlineFileDownload size={20} />
//             </CustomButton>

//             <CustomButton
//               onClick={() => setIsVersionsModal(true)}
//               btnName="Versions"
//               customClasses="shadow-md font-medium border py-1 px-6 ml-4"
//             />

//             {checkPermission(permissions.CREATE_SALARY_RANGE) && (
//               <CustomButton
//                 onClick={() => setIsVisible(true)}
//                 btnName="Create Salary Range"
//                 customClasses="shadow-md font-medium border py-1 px-6 ml-4"
//               />
//             )}
//           </div>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="jobCreationListing mt-10 bg-white px-14 py-6 rounded-lg">
//         <SearchBox
//           placeholder="Type to search..."
//           value={searchInput}
//           onChange={value => setSearchInput(value)}
//         />

//         {/* ✅ COLUMN TOGGLE UI */}
//         <div className="mb-4 flex flex-wrap gap-3">
//           {allColumns.map(col => {
//             const isActionsColumn = col.key === "actions";
//             const isChecked = visibleColumnKeys.includes(col.key);

//             const isDisabled =
//               isActionsColumn || (isChecked && visibleColumnKeys.length <= 3);

//             return (
//               <label key={col.key}>
//                 <input
//                   type="checkbox"
//                   checked={isChecked}
//                   disabled={isDisabled}
//                   onChange={() => {
//                     if (isActionsColumn) return;

//                     if (isChecked) {
//                       setVisibleColumnKeys(prev =>
//                         prev.filter(key => key !== col.key)
//                       );
//                     } else {
//                       setVisibleColumnKeys(prev => [...prev, col.key]);
//                     }
//                   }}
//                 />
//                 <span style={{ marginLeft: 6 }}>{col.title}</span>
//               </label>
//             );
//           })}
//         </div>

//         <Table
//           isLoading={isLoading}
//           data={updatedData}
//           columns={filteredColumns}
//           scroll={1300}
//           pagination={true}
//           count={pagination?.count}
//           onChangePage={setPage}
//           onPageSizeChange={setPageSize}
//           page={page}
//           onTableChange={(pagination, filters, sorter) => {
//             if (sorter?.field) {
//               const order = sorter.order === "ascend" ? "" : "-";
//               setSortBy(`${order}${sorter.field}`);
//               setPage(1);
//             }
//           }}
//         />
//       </div>
//     </>
//   );
// };

// export default SalaryRange;

import { message, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Table from "@components/Table";
import { getColumns } from "./config";
import {
  ErrorServices,
  salaryRangeApi,
  useDeleteSalaryRangeMutation,
  useFetchCompanySalaryRangesQuery,
  useUploadSalaryRangesMutation,
} from "@services";
import AddSalaryRange from "./AddSalaryRange";
import { ISalaryRange } from "@types";
import SalaryRangeVersions from "./Versions";
import Upload from "@components/Upload";
import { useTypedSelector } from "@hooks";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import CustomButton from "@/components/customButton";
import { MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
import SearchBox from "@/components/searchInput";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
import customErrorMessage from "@/components/CustomErrorMessage";
import { Checkbox } from "antd";

const SalaryRange = () => {
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const dispatch = useDispatch();
  const salary_range_id = useRef<any>(null);

  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [isVisible, setIsVisible] = useState(false);
  const [isUploadModal, setIsUploadModal] = useState(false);
  const [selectedSalaryRange, setSelectedSalaryRange] =
    useState<ISalaryRange | null>(null);
  const [isVersionsModal, setIsVersionsModal] = useState(false);
  const [sortBy, setSortBy] = useState<string | null>(null);
  const [order, setOrder] = useState<"asc" | "desc" | null>(null);

  const { data: salaryRanges, isLoading } = useFetchCompanySalaryRangesQuery({
    company_id,
    page,
    page_size: pageSize,
    sort_by: sortBy,
    order:order
  });

  const { data, pagination } = salaryRanges || {};

  const [deleteSalaryRange, { isLoading: isDeleting }] =
    useDeleteSalaryRangeMutation();

  const [uploadFile, setUploadFile] = useState({
    file: null,
    active: false,
  });

  const [uploadJobGrades, { isLoading: isUploading }] =
    useUploadSalaryRangesMutation();

  const editSalaryRange = (salaryRange: ISalaryRange) => {
    setSelectedSalaryRange(salaryRange);
    setIsVisible(true);
  };

  const updatedData =
    data &&
    data.map((item: any) => ({
      ...item,
      salary_mid: formatNumberWithCommas(item.salary_mid) || item.salary_mid,
      salary_min: formatNumberWithCommas(item.salary_min) || item.salary_min,
      salary_max: formatNumberWithCommas(item.salary_max) || item.salary_max,
    }));

  const removeSalaryRange = async (id: number) => {
    try {
      salary_range_id.current = id;
      await deleteSalaryRange({ company_id, id }).unwrap();
      message.success("Salary range deleted successfully!");
    } catch (error) {
      ErrorServices(error);
    }
  };

  const handleUpload = async () => {
    const { file, active }: { file: any; active: boolean } = uploadFile;
    setIsUploadModal(false);
    try {
      const formData = new FormData();
      formData.append("attachment", file!, file?.name!);
      const res = await uploadJobGrades({
        company_id,
        active,
        body: formData,
      }).unwrap();
      message.success(res?.message);
    } catch (error: any) {
      customErrorMessage(error?.message);
    }
  };

  const download = (id?: number) => {
    dispatch(
      salaryRangeApi.endpoints.downloadSalaryRanges.initiate(
        {
          company_id,
          version_id: id || null,
        },
        {
          subscribe: false,
          forceRefetch: true,
        }
      )
    );
  };

  // ✅ ALL COLUMNS
  const allColumns = getColumns({
    editSalaryRange,
    isDeleting,
    salary_range_id,
    removeSalaryRange,
  });

  // ✅ COLUMN STATE
  const [visibleColumnKeys, setVisibleColumnKeys] = useState(
    allColumns.map(col => col.key)
  );

  // ✅ Ensure Actions column always present
  useEffect(() => {
    if (!visibleColumnKeys.includes("actions")) {
      setVisibleColumnKeys(prev => [...prev, "actions"]);
    }
  }, []);

  // ✅ FILTERED COLUMNS
  const filteredColumns = allColumns.filter(col =>
    visibleColumnKeys.includes(col.key)
  );

  // custom overlay
  const columnOverlay = (
    <div
      style={{
        background: "#fff",
        padding: 8,
        borderRadius: 6,
        boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
        minWidth: 240,
        maxHeight: 300,
        overflowY: "auto",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {allColumns.map((col) => {
        const isActionsColumn = col.key === "actions";
        const isChecked = visibleColumnKeys.includes(col.key);
        const isDisabled =
          isActionsColumn || (isChecked && visibleColumnKeys.length <= 3);

        return (
          <label
            key={col.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "6px 8px",
              borderRadius: 4,
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              disabled={isDisabled}
              onChange={() => {
                if (isActionsColumn) return;

                if (isChecked) {
                  setVisibleColumnKeys((prev) =>
                    prev.filter((key) => key !== col.key)
                  );
                } else {
                  setVisibleColumnKeys((prev) => [...prev, col.key]);
                }
              }}
              style={{
                margin: 0,
                width: 16,
                height: 16,
                flexShrink: 0,
              }}
            />

            <span
              style={{
                flex: 1,
                fontSize: 14,
                lineHeight: "18px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {col.title}
            </span>
          </label>
        );
      })}
    </div>
  );

  return (
    <>
      {isUploadModal && (
        <Upload
          title="Upload Salary Ranges"
          onSubmit={handleUpload}
          isVisible={isUploadModal}
          setIsVisible={setIsUploadModal}
          file={uploadFile}
          setFile={setUploadFile}
        />
      )}

      {isVisible && (
        <AddSalaryRange
          selectedSalaryRange={selectedSalaryRange}
          setSelectedSalaryRange={setSelectedSalaryRange}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
        />
      )}

      {isVersionsModal && (
        <SalaryRangeVersions
          isVisible={isVersionsModal}
          setIsVisible={setIsVersionsModal}
          download={download}
        />
      )}

      {/* HEADER */}
      <div className="bg-themeCore ">
        <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center ">
          <div className="title text-themeBlue font-medium text-3xl">
            Salary Range
          </div>

          <div className="flex flex-row justify-between">
            {(checkPermission(permissions.UPDATE_SALARY_RANGE) ||
              checkPermission(permissions.CREATE_SALARY_RANGE)) && (
                <CustomButton
                  isLoading={isUploading}
                  onClick={() => setIsUploadModal(true)}
                  btnName="Upload"
                  customClasses="shadow-md font-medium border py-1 px-6"
                >
                  <MdOutlineFileUpload size={20} />
                </CustomButton>
              )}

            <CustomButton
              onClick={() => download()}
              btnName="Download"
              customClasses="shadow-md font-medium border py-1 px-6 ml-4"
            >
              <MdOutlineFileDownload size={20} />
            </CustomButton>

            <CustomButton
              onClick={() => setIsVersionsModal(true)}
              btnName="Versions"
              customClasses="shadow-md font-medium border py-1 px-6 ml-4"
            />

            {checkPermission(permissions.CREATE_SALARY_RANGE) && (
              <CustomButton
                onClick={() => setIsVisible(true)}
                btnName="Create Salary Range"
                customClasses="shadow-md font-medium border py-1 px-6 ml-4"
              />
            )}
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="jobCreationListing mt-10 bg-white px-14 py-6 rounded-lg">

        {/* ✅ COLUMN DROPDOWN */}
        <div className="flex items-center justify-end gap-2">
          <SearchBox
            placeholder="Type to search..."
            value={searchInput}
            onChange={value => setSearchInput(value)}
          />
          <Dropdown
            overlay={columnOverlay}
            trigger={["click"]}
            placement="bottomLeft"
          // getPopupContainer={trigger => trigger.parentElement}
          >
            <CustomButton
              btnName="Columns"
              customClasses="shadow-md font-medium border py-1 px-4"
            >
              <DownOutlined style={{ marginLeft: 6 }} />
            </CustomButton>
          </Dropdown>
        </div>

        <Table
          isLoading={isLoading}
          data={updatedData}
          columns={filteredColumns}
          scroll={1300}
          pagination={true}
          count={pagination?.count}
          onChangePage={setPage}
          onPageSizeChange={setPageSize}
          page={page}
          onTableChange={(pagination, filters, sorter) => {
            if (sorter?.field) {
              setSortBy(sorter.field);
              setOrder(sorter.order === "ascend" ? "asc" : "desc");
              setPage(1);
            }
          }}
        />
      </div>
    </>
  );
};

export default SalaryRange;